import React, { Component } from "react";
import { observer } from "mobx-react";
import { PropTypes } from "prop-types";
import { withTranslation } from "react-i18next";
import { Dropdown } from "semantic-ui-react";
import { Link } from "react-router-dom";
import CustomDomainLogo from "~/components/CustomDomainLogo";
import DomainNameUtils from "~/utils/DomainNameUtils";
import AuthenticatedUserHelper from "~/utils/AuthenticatedUserHelper";
import User from "~/models/User";
import Header from "./Header";
import "~/styles/tourbuzz/Header.less";

@observer
class TourbuzzHeader extends Component {
  componentDidMount() {
    // Update the favicon if we are in a custom domain.
    // Might not be the best place to do this, but it's handy since here we have access to the user.
    // Feel free to move it to a better place if needed.
    if (DomainNameUtils.isCustomDomain() && window.templateDefaults.faviconUrl) {
      const link = document.querySelector("link[rel*='icon']") || document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      // Note that favicon might be empty. We don't really care about it since there's no fallback and
      // in any case it would override any unwanted cached favicon.
      link.href = window.templateDefaults.faviconUrl;
      document.getElementsByTagName("head")[0].appendChild(link);
    }
  }

  render() {
    const { user, t } = this.props;

    // Build the logo first
    let logo = <img src="/skins/tourbuzz/default/shared/img/new_tb_logo_white.png" alt="Tourbuzz Logo" />;

    if (DomainNameUtils.isCustomDomain()) {
      logo = (
        <CustomDomainLogo
          logoUrl={window.templateDefaults.customBranding.logoUrl}
          company={window.templateDefaults.customBranding.company}
        />
      );
    }

    // Links at the logo
    let headerContentLogo = logo;
    const validUserAndNavigation =
      DomainNameUtils.isClientPanel() && AuthenticatedUserHelper.isAuthenticatedCustomer(user);

    if (DomainNameUtils.isCustomDomain() && window.templateDefaults.customBranding.providerUrl) {
      headerContentLogo = (
        <a target="_blank" rel="noopener noreferrer" href={window.templateDefaults.customBranding.providerUrl}>
          {logo}
        </a>
      );
    } else if (validUserAndNavigation) {
      headerContentLogo = <Link to="/tours">{logo}</Link>;
    }

    const accountMenu = (
      <Dropdown.Menu position="right">
        {validUserAndNavigation && (
          <>
            <Dropdown.Item as={Link} to="/profile/account">
              {t("profileSettings")}
            </Dropdown.Item>
            {user.provider.enableClientPanelSubscriptions && (
              <Dropdown.Item as={Link} to="/billing-central">
                {t("billingCentral:billingCentral")}
              </Dropdown.Item>
            )}
            {user.enableClientYoutubeSetup && (
              <Dropdown.Item as={Link} to="/profile/youtube">
                {t("youtube:youtubeSetup")}
              </Dropdown.Item>
            )}
            <Dropdown.Item as={Link} to="/profile/pages">
              {t("customerPortal:myPages")}
            </Dropdown.Item>
            {user.provider.enableClientPanelSubscriptions && (
              <Dropdown.Item as={Link} to="/ui-meet-3d">
                {t("uiMeet3d")}
              </Dropdown.Item>
            )}
          </>
        )}
        <Dropdown.Item as="a" href="/login/doLogout">
          {t("logOut")}
        </Dropdown.Item>
      </Dropdown.Menu>
    );

    const navMenuElements = [];

    if (DomainNameUtils.isClientPanel() && AuthenticatedUserHelper.isAuthenticatedCustomer(user)) {
      navMenuElements.push(<Link to="/tours">{t("myTours")}</Link>);

      if (window.templateDefaults.orderFormUrl) {
        navMenuElements.push(
          <a target="_blank" rel="noopener noreferrer" href={window.templateDefaults.orderFormUrl}>
            {t("orderTour")}
          </a>,
        );
      }
    }

    return (
      <Header
        user={user}
        headerContentLogo={headerContentLogo}
        accountMenu={accountMenu}
        navMenuElements={navMenuElements}
        supportUrl="https://help.tourbuzz.com/"
      />
    );
  }
}

TourbuzzHeader.propTypes = {
  t: PropTypes.func.isRequired,
  user: PropTypes.instanceOf(User),
};

export default withTranslation()(TourbuzzHeader);
